import { render, staticRenderFns } from "./ForgotPassword-v2.vue?vue&type=template&id=6b7a625f&scoped=true&"
import script from "./ForgotPassword-v2.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword-v2.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword-v2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ForgotPassword-v2.vue?vue&type=style&index=1&id=6b7a625f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7a625f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VForm,VIcon,VImg,VRow,VTextField})
